import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, renderSlot, createCommentVNode, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "elfie-banner__icon"
};
const _hoisted_2 = { class: "elfie-banner__content" };
const _hoisted_3 = {
  key: 0,
  class: "elfie-banner__title"
};
const _hoisted_4 = {
  key: 1,
  class: "elfie-banner__description"
};
const _hoisted_5 = {
  key: 1,
  class: "elfie-banner__actions"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Banner",
  props: {
    layout: { default: "inline" },
    variant: { default: "danger" },
    title: { default: void 0 },
    description: { default: void 0 }
  },
  setup(__props) {
    const props = __props;
    const rootClass = computed(() => ["elfie-banner", `elfie-banner--${props.layout}`, `elfie-banner--${props.variant}`]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(rootClass.value)
      }, [
        _ctx.$slots.icon ? (openBlock(), createElementBlock("div", _hoisted_1, [
          renderSlot(_ctx.$slots, "icon", {}, void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("div", _hoisted_2, [
          __props.title ? (openBlock(), createElementBlock("p", _hoisted_3, toDisplayString(__props.title), 1)) : createCommentVNode("", true),
          __props.description ? (openBlock(), createElementBlock("p", _hoisted_4, toDisplayString(__props.description), 1)) : createCommentVNode("", true),
          renderSlot(_ctx.$slots, "content", {}, void 0, true)
        ]),
        _ctx.$slots.actions ? (openBlock(), createElementBlock("div", _hoisted_5, [
          renderSlot(_ctx.$slots, "actions", {}, void 0, true)
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Banner.vue2.js.map
